// extracted by mini-css-extract-plugin
export default {"puzzleContainer":"style_puzzleContainer__6q+UJ","line":"style_line__cH9Zd","horizontalLine":"style_horizontalLine__uNL0t","verticalLine":"style_verticalLine__D9dDh"};